const ORDER_MODEL_KEY_POINTER = require('models/daos/order/constants/index.cjs').ORDER_MODEL_KEY_POINTER

const ORDERS_DOMAIN = 'orders'

const ORDERS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const ORDERS_PATH = {
  DATA: `${ORDERS_DOMAIN}.data`,
  ALL: `${ORDERS_DOMAIN}.all`
}

/**
 * API endpoints.
 * @type {Object}
 */
const ORDERS_ENDPOINT = {
  CANCEL: '/orders/cancel',
  GET_SHIPPING_LABEL: '/orders/getShippingLabel'
}

const ORDERS_DOMAIN_MAP_KEY = ORDER_MODEL_KEY_POINTER

module.exports = {
  ORDERS_PATH,
  ORDERS_ENDPOINT,
  ORDERS_DOMAIN,
  ORDERS_STATE,
  ORDERS_DOMAIN_MAP_KEY
}
